import VitalSigns from 'dashboard/templates/views/Encounter/VitalSigns';

export default {
  path: 'vital-signs',
  name: 'PatientEncounterVitalSigns',
  component: VitalSigns,
  meta: {
    // title: 'Encounter - Vital Signs',
    title: t => t('encounter.vitalSigns'),
    loggedInOnly: true,
  }
};
